import { ArrowLeft } from "lucide-react";
import { BillingPackage } from "../types/BillingPackage";
import { usePackagesStore } from "../store/packagesStore";
import Swal from "sweetalert2";
import { useState } from "react";

interface EditPackageFormProps {
    onClose: () => void;
    selectedPackage: BillingPackage | null;
}

export default function EditPackageForm({ onClose, selectedPackage }: EditPackageFormProps) {

    const { deletePackage, updatePackage } = usePackagesStore();

    const [formData, setFormData] = useState({
        name: selectedPackage?.name || "",
        description: selectedPackage?.description || "",
        price: selectedPackage?.price || 0,
        duration: selectedPackage?.duration || 0,
    });

    if (!selectedPackage) return null;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleDelete = async (id: string) => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel",
        });

        if (confirm.isConfirmed) {
            const result = await deletePackage(id);

            Swal.fire({
                icon: result.success ? "success" : "error",
                title: result.success ? "Deleted!" : "Error",
                text: result.message,
            });

            onClose();
        }
    };

    const handleSave = async () => {
        const result = await updatePackage(selectedPackage._id, formData);
        if (result.status === "success") {
            Swal.fire("Success", result.message, "success");
          } else {
            Swal.fire("Error", result.message, "error");
          }
        if (result.status === "success") onClose();
    };


    return (
        <div className="w-full flex flex-col mt-14">
            <div className="w-full flex justify-between">
                <div className="flex items-center gap-x-1 text-xs text-white cursor-pointer hover:text-gray-300" onClick={onClose}>
                    <ArrowLeft size={12} />
                    Back
                </div>
                <button
                    onClick={() => handleDelete(selectedPackage._id)}
                    className="bg-red-500 rounded py-1 px-2 text-sm text-white"
                >
                    Delete
                </button>
            </div>

            {/* Form fields */}
            <div className="py-2">
                <p className="text-white text-xs">Package Name</p>
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full bg-white rounded-md p-2 text-black text-xs"
                />
            </div>

            <div className="py-2">
                <p className="text-white text-xs">Description</p>
                <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="w-full bg-white rounded-md p-2 text-black text-xs"
                />
            </div>

            <div className="py-2">
                <p className="text-white text-xs">Price</p>
                <input
                    type="number"
                    name="price"
                    value={formData.price}
                    onChange={handleChange}
                    className="w-full bg-white rounded-md p-2 text-black text-xs"
                />
            </div>

            <div className="py-2">
                <p className="text-white text-xs">Duration</p>
                <input
                    type="number"
                    name="duration"
                    value={formData.duration}
                    onChange={handleChange}
                    className="w-full bg-white rounded-md p-2 text-black text-xs"
                />
            </div>

            <button
                onClick={handleSave}
                className="py-1 px-4 rounded-md bg-white hover:scale-105 text-black text-sm mx-auto my-4"
            >
                Save
            </button>
        </div>
    );
}